export default __webpack_public_path__ + "static/media/gallery_09.0e732264.jpg";